export const EXPERIMENTS = {
  TARGET_SETTING: 'specs.forms.ComposerTargetSetting',
  MOVE_ECOM_LABEL_TRANSLATIONS: 'specs.forms.MoveEcomLabelTranslations',
  CLEAR_ON_AUTOFILL: 'specs.forms.ClearOnAutofill',
  BULK_EDIT_OPTIONS: 'specs.forms.OptionsBulkEdit',
  ENABLE_DUPLICATE: 'specs.forms.EnableDuplicate',
  ENHANCE_ECOM_SETTINGS: 'specs.forms.EnhanceEcomSettings',
  ENABLE_SHORTCUTS: 'specs.forms.EnableShortcuts',
  DOUBLE_OPT_IN_SETTING: 'specs.forms.DoubleOptInSettings',
  CHOICES_LAYOUT_SETTING: 'specs.forms.ChoicesLayoutSetting',
  TRANSLATE_ECOM_EMAIL: 'specs.forms.TranslateEcomEmail',
  MULTILINE_ADDRESS_IN_TEMPLATES: 'specs.forms.MultilineAddressInTemplates',
  PREFILL_PLACEHOLDER: 'specs.forms.PrefillPlaceholder'
};
//# sourceMappingURL=experiments.js.map